import { TreeNode } from '../route-builder';

export const OrgReviewModule = {
  segment: 'org-review',
  children: {
    OrgReviewAdjustmentsComponent: { segment: 'adjustments', params: ['headId', 'orgCode'] },
    OrgReviewActivityStreamComponent: { segment: 'activity-stream' }
  }
} as const satisfies TreeNode;
